import { createFetcher } from './Fetcher';

export default createFetcher(({ autoSharingStore }, { showId, provider }) => ({
    fetch: () => showId && autoSharingStore.fetchShowTemplate(showId, provider),
    isLoading: autoSharingStore.fetchShowTemplate.pending,
    input: [showId, provider],
}));
